import { CapoPlugin } from "/home/runner/work/doxa-frontend/doxa-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];